import { ProjectShape } from 'utils/shapes';
import reverseUrl from 'utils/urls';
import moment from 'moment';
import Preview from '../Preview';

moment.locale('nb');

const getUrl = (project) =>
    reverseUrl('trafo_project_details_with_seotitle', {
        pk: project.id,
        seotitle: project.seo_title,
    });

const SingleProject = ({ project }) =>
    Preview({
        url: getUrl(project),
        title: project.title,
        subtitle: project.project_type,
        description: project.ingress,
        image: project.facade_thumbnail_large_url,
    });

SingleProject.propTypes = {
    project: ProjectShape.isRequired,
};

export default SingleProject;



// WEBPACK FOOTER //
// ./src/components/projects/SingleProject.js